import {StyleSheet} from 'react-native';

import {bottomSpace} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  messageBanner: {
    position: 'absolute',
    zIndex: 1,
    elevation: 1,
    width: '100%',
    bottom: bottomSpace,
  },
});
